import React, { useEffect, useRef } from "react";
import GuestMessageComp from "./GuestMessageComp";
import UserMessageComp from "./UserMessageComponent";
import { capitalizeText } from "../../../utils/constant";
import moment from "moment";
import { useSelector } from "react-redux";
import DateRangeDisplay from "../DateRangeDisplay";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBackward } from "@fortawesome/free-solid-svg-icons";
import { Height } from "@mui/icons-material";

const ChatMessages = ({ assetsurl, moveToThirdStep, type, setStep }) => {
  const {
    selectedRoomIdMessages,
    messagesLoading,
    messagesError,
    rightSideContent,
  } = useSelector((state) => state.Message);

  const navigate = useNavigate();
  const location = useLocation();

  const messageContainerRef = useRef();
  const isSmallScreen = window.innerWidth <= 500;

  useEffect(() => {
    // Scroll to the bottom when messageArray changes
    // if (messagesLoading) {
    //   setMessages([]);
    // }

    if (messageContainerRef.current && !messagesLoading) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight;
    }
  }, [selectedRoomIdMessages, messagesLoading]);

  const reloadWithoutQueryParams = () => {
    // Get the current pathname without query params
    const pathnameWithoutQuery = location.pathname;

    // Construct the full URL without query parameters
    const urlWithoutQueryParams = `${window.location.origin}${pathnameWithoutQuery}`;

    // Reload the page without query parameters
    window.location.assign(urlWithoutQueryParams);
  };

  return (
    <div
      className="message-middle-subchild-div"
      style={{ overflowY: "hidden", height: isSmallScreen ? "98%" : null }}
    >
      {rightSideContent && (
        <div className="mesage-middle-top-section">
          {isSmallScreen && (
            <button
              onClick={() => setStep(-1)}
              style={{ background: "transparent", border: "none" }}
            >
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
          )}

          <p style={{ fontSize: "15px", fontWeight: "600" }}>
            {type === 0
              ? capitalizeText(rightSideContent?.chat_users?.[1]?.fname)
              : capitalizeText(rightSideContent?.chat_users?.[0]?.fname)}{" "}
            <span>
              <DateRangeDisplay
                startDate={rightSideContent?.lead_event_details[0].checkin_date}
                endDate={rightSideContent?.lead_event_details[0].checkout_date}
              />
            </span>
          </p>

          {/* <p  style={{fontSize:'11px',color:'#707980'}}>Last seen 11hr ago</p> */}

          {isSmallScreen && (
            <span onClick={moveToThirdStep} class="material-symbols-outlined">
              info
            </span>
          )}
        </div>
      )}
      <div
        className="message-middle-subchild-div"
        ref={messageContainerRef}
        style={{
          height: "100%",
        }}
        // style={{
        //   height: "calc(80vh - 94px) !important",
        // }}
      >
        {messagesLoading && <p>Loading...</p>}

        {!messagesLoading && selectedRoomIdMessages.length == 0 && (
          <h3>No messages found</h3>
        )}

        {!messagesLoading &&
          selectedRoomIdMessages &&
          selectedRoomIdMessages
            .slice()
            .reverse()
            .map((message) => {
              if (!message.message || message.message.trim() === "") {
                // Skip rendering for null or empty messages
                return null;
              }

              // if (message.you == 0 && message.message_from != type)
              // else if (message.you == 1)

              // console.log("Message => ", message);
              if (
                (type == 0 && message.message_from != 0) ||
                (type != 0 && message.message_from == 0)
              ) {
                // console.log(message.message_from, "checkArray");

                return (
                  <GuestMessageComp
                    key={message.createdon}
                    guestName={capitalizeText(
                      rightSideContent?.chat_users?.[message.message_from]
                        ?.fname
                    )}
                    messageText={message.message}
                    messageTime={moment.utc(message.createdon).format("HH:mm")}
                    guestImg={
                      rightSideContent?.chat_users?.[type === 1 ? 0 : 1]?.image
                        ? assetsurl +
                          rightSideContent?.chat_users?.[type === 1 ? 0 : 1]
                            ?.image
                        : undefined
                    }
                  />
                );
              } else if (message.you == 1) {
                // console.log(message.createdon, "checkDates");
                return (
                  <UserMessageComp
                    key={message.createdon}
                    messageText={message.message}
                    // messageTime={moment(message.createdon).format('HH:mm')}
                    messageTime={moment.utc(message.createdon).format("HH:mm")}
                  />
                );
              }
              return null; // Skip rendering for other cases
            })}
      </div>
    </div>
  );
};

export default ChatMessages;
